import { useMutation, useQueryClient } from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { HibernationScheduleUpdate } from '@cast/types-cluster-autoscaler';

import { getHibernationSchedulesQueryKey } from 'hooks/queries/cluster-autoscaler/useGetHibernationSchedulesQuery';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

export const useUpdateHibernationScheduleMutation = () => {
  const { currentOrganization } = useOrganizations();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      hibernationScheduleUpdate,
    }: {
      id: string;
      hibernationScheduleUpdate: HibernationScheduleUpdate;
    }) => {
      return apiClient.clusterAutoscaler.updateHibernationSchedule({
        organizationId: currentOrganization!.id,
        id,
        hibernationScheduleUpdate,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getHibernationSchedulesQueryKey(currentOrganization!.id),
      });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
